var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import _ from 'lodash';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { FORMATTER_TYPE_INFO_BY_TYPE, FORMATTER_TYPE_NAMES } from '@/ducks/ui/formatters';
import { Icon, Input, usePreferences } from '@/ui-toolkit';
import { AnimationIconNavigation } from '@/ui-toolkit/elements/Icon/animation/NavigationIcon';
import { Badge, Table } from '@/ui-toolkit/indexExportV2';
export var CustomPagesTable = function (_a) {
    var _b;
    var formatters = _a.formatters;
    var _c = usePreferences(), preferences = _c.preferences, setPreference = _c.setPreference;
    var history = useHistory();
    var search = (_b = preferences.search) !== null && _b !== void 0 ? _b : '';
    var handleSearch = _.debounce(function (ev) {
        setPreference('search', ev.target.value);
    }, 300);
    var navigateToCustomPageDetails = function (customPageId) {
        history.push("/admin/custom-pages/".concat(customPageId));
    };
    var memoizedCustomPagesList = useMemo(function () {
        return _.chain(formatters)
            .filter(function (formatter) { return formatter.formatterType === 'page' || formatter.formatterType === 'publicPage'; })
            .sortBy('name')
            .value();
    }, [formatters]);
    var filteredCustomPagesList = useMemo(function () {
        return _.filter(memoizedCustomPagesList, function (customPage) {
            return customPage.name.toLowerCase().includes(search.toLowerCase());
        });
    }, [memoizedCustomPagesList, search]);
    return (React.createElement(FadeInWrapper, null,
        React.createElement(Input, { autoFocus: true, raw: true, prefix: React.createElement(Icon, { name: "search" }), type: "search", placeholder: "Search", defaultValue: search, onChange: handleSearch }),
        React.createElement(Table, null,
            React.createElement("thead", null,
                React.createElement(Table.Row, null,
                    React.createElement(Table.Header, null, "Name"),
                    React.createElement(Table.Header, { colSpan: 2 }, "Type"))),
            React.createElement("tbody", null,
                !_.isEmpty(memoizedCustomPagesList) &&
                    _.map(filteredCustomPagesList, function (customPage) {
                        var typeInfo = FORMATTER_TYPE_INFO_BY_TYPE[customPage.formatterType];
                        return (React.createElement(Table.Row, { key: customPage.id, onClick: function () { return navigateToCustomPageDetails(customPage.id); } },
                            React.createElement(Table.Data, null, customPage.name),
                            React.createElement(Table.Data, null,
                                React.createElement(Badge, { color: typeInfo.color },
                                    React.createElement(Icon, { color: typeInfo.color, name: typeInfo.icon }),
                                    FORMATTER_TYPE_NAMES[customPage.formatterType])),
                            React.createElement(Table.Data, null,
                                React.createElement(AnimationIconNavigation, null))));
                    }),
                _.isEmpty(memoizedCustomPagesList) && (React.createElement(Table.Row, null,
                    React.createElement(Table.Data, { colSpan: 2 }, "No custom pages available")))))));
};
export var fadeInAnimation = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    opacity: 0;\n    transform: translateY(-16px);\n\n    animation: fade 0.8s ease-out forwards;\n\n    @keyframes fade {\n        from {\n            opacity: 0;\n            transform: translateY(-16px);\n        }\n        to {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n"], ["\n    opacity: 0;\n    transform: translateY(-16px);\n\n    animation: fade 0.8s ease-out forwards;\n\n    @keyframes fade {\n        from {\n            opacity: 0;\n            transform: translateY(-16px);\n        }\n        to {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n"])));
// Styled component with the fade-in effect and topdown translation
export var FadeInWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), fadeInAnimation);
var templateObject_1, templateObject_2;
